/**
 * 창 단축키 공용 가드 — 전체화면 창 셸(탭 이동)·영상 플레이어(재생)·에피소드 목록(이동)·
 * 리뷰 독(태그·저장)이 함께 쓴다.
 *
 * 이 핸들러들은 모두 `window` 에 붙는다. 포커스를 요구하지 않아야 목록이나 영상을 클릭하지
 * 않고도 바로 훑을 수 있기 때문인데, 그러면 화면에 보이지 않는 표면까지 같은 키를 받는다.
 * 아래 세 가드가 그 범위를 좁힌다.
 */

/**
 * 이 표면이 지금 키를 받아도 되는가.
 *
 * 전체화면 창(`FullscreenWindow`)이 열리면 뒤의 라우트 페이지는 `inert` 처리되지만 `inert` 는
 * window 레벨 keydown 을 막지 못한다 — 가드가 없으면 보이지 않는 배경 화면에서 리뷰가
 * 저장된다. 창 위에 c6 Modal 이 뜬 경우도 같은 규칙으로 걸린다(스택이 창을 inert 로 잠근다).
 * 최소화된 창은 본문을 보존하면서 셸을 inert 처리하므로 같은 가드로 걸러진다.
 */
export function isHotkeySurfaceActive(root: HTMLElement | null): boolean {
  if (root === null || !root.isConnected) {
    return false;
  }
  return root.closest("[inert]") === null;
}

/** 입력 중인 요소(텍스트 입력·contenteditable)에 포커스가 있으면 단축키를 잡지 않는다. */
export function isEditableKeyboardTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const tagName = target.tagName.toLowerCase();
  return (
    target.isContentEditable ||
    target.closest('[contenteditable="true"]') !== null ||
    tagName === "input" ||
    tagName === "textarea" ||
    tagName === "select"
  );
}

/** 수식 키가 하나라도 눌려 있으면 앱 단축키가 아니라 브라우저·OS 조합으로 본다. */
export function hasModifierKey(event: KeyboardEvent): boolean {
  return event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}
